import { render, staticRenderFns } from "./StaticPage3.vue?vue&type=template&id=722f7dc8&scoped=true"
import script from "./StaticPage3.vue?vue&type=script&lang=js"
export * from "./StaticPage3.vue?vue&type=script&lang=js"
import style0 from "./StaticPage3.vue?vue&type=style&index=0&id=722f7dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722f7dc8",
  null
  
)

export default component.exports